// units for distances

export const METRIC = 'METRIC'
export const IMPERIAL = 'IMPERIAL'
